var map = {
	"./ca": [
		"node_modules/react-intl/locale-data/ca.js",
		15
	],
	"./cs": [
		"node_modules/react-intl/locale-data/cs.js",
		14
	],
	"./de": [
		"node_modules/react-intl/locale-data/de.js",
		13
	],
	"./en": [
		"node_modules/react-intl/locale-data/en.js",
		12
	],
	"./es": [
		"node_modules/react-intl/locale-data/es.js",
		11
	],
	"./fr": [
		"node_modules/react-intl/locale-data/fr.js",
		10
	],
	"./gl": [
		"node_modules/react-intl/locale-data/gl.js",
		9
	],
	"./it": [
		"node_modules/react-intl/locale-data/it.js",
		8
	],
	"./ja": [
		"node_modules/react-intl/locale-data/ja.js",
		7
	],
	"./ko": [
		"node_modules/react-intl/locale-data/ko.js",
		6
	],
	"./nl": [
		"node_modules/react-intl/locale-data/nl.js",
		5
	],
	"./pl": [
		"node_modules/react-intl/locale-data/pl.js",
		4
	],
	"./pt": [
		"node_modules/react-intl/locale-data/pt.js",
		3
	],
	"./ru": [
		"node_modules/react-intl/locale-data/ru.js",
		2
	],
	"./sv": [
		"node_modules/react-intl/locale-data/sv.js",
		1
	],
	"./zh": [
		"node_modules/react-intl/locale-data/zh.js",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "node_modules/react-intl/locale-data lazy recursive \\/(ca|cs|de|en|es|fr|gl|it|ja|ko|nl|pl|pt|ru|sv|zh)$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-intl/locale-data lazy \/(ca|cs|de|en|es|fr|gl|it|ja|ko|nl|pl|pt|ru|sv|zh)$
// module id = node_modules/react-intl/locale-data lazy recursive \/(ca|cs|de|en|es|fr|gl|it|ja|ko|nl|pl|pt|ru|sv|zh)$
// module chunks = 32